import React from 'react';
import { Link } from 'react-router-dom';
import { LuFacebook, LuInstagram, LuLinkedin, LuYoutube } from "react-icons/lu";

import logo from '../../assets/images/logo.png';

const path = "/tutor";

const Nav = () => {
    return (
        <nav>
            <div className="navMain">
                <div className="navCol1">
                    <Link to={`${path}/`} className="navLogo">
                        <img src={logo} alt="Logo" />
                    </Link>
                </div>
                <div className="navCol2">
                    <div className="navSocialLinks">
                        <ul>
                            <li>
                                <Link to="https://www.facebook.com/athenacoachinginternational" target="_blank" rel="noreferrer">
                                    <LuFacebook />
                                </Link>
                            </li>
                            <li>
                                <Link to="https://www.instagram.com/athenacoachingcentre/" target="_blank" rel="noreferrer">
                                    <LuInstagram />
                                </Link>
                            </li>
                            <li>
                                <Link to="https://www.linkedin.com/company/athena-coaching-centre" target="_blank" rel="noreferrer">
                                    <LuLinkedin />
                                </Link>
                            </li>
                            <li>
                                <Link to="https://m.youtube.com/channel/UCDmMxK9qV7BL6i1I4As78yw" target="_blank" rel="noreferrer">
                                    <LuYoutube />
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="navContact">
                        <div className="navContactBtn">Contact Now</div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Nav;